function toggleRegType(regType, registerBlocks) {
  registerBlocks
    .querySelectorAll('.register-intro-blocks')
    .forEach((el) => el.classList.add('has-selection'));

  registerBlocks
    .querySelectorAll('.intro-block.active')
    .forEach((el) => el.classList.remove('active'));

  document
    .querySelectorAll('[data-reg-type-link="' + regType + '"]')
    .forEach((el) => {
      const intro = el.closest('.intro-block');
      if (intro) intro.classList.add('active');
    });

  registerBlocks
    .querySelectorAll('.register-detail.open')
    .forEach((el) => el.classList.remove('open'));

  var target = document.querySelector('[data-reg-type="' + regType + '"]');

  if (target) {
    target.classList.add('open');
    target.scrollIntoView();
  }
}

const initRegisterBlocks = () => {
  const registerBlocks = document.querySelector('.act-register-blocks');

  if (!registerBlocks) return;

  registerBlocks
    .querySelectorAll('.intro-block [data-reg-type-link]')
    .forEach((btn) => {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var regType = this.dataset.regTypeLink;
        toggleRegType(regType, registerBlocks);
      });
    });

  var regTypeHash = location.hash;

  if (
    regTypeHash &&
    document.querySelector('[data-reg-type="' + regTypeHash + '"]')
  ) {
    toggleRegType(regTypeHash, registerBlocks);
  }
};

document.addEventListener("DOMContentLoaded", initRegisterBlocks);